export function queryParamsToObject(url: string): URLSearchParams {
  const [, queryString] = url.split('?');

  return new URLSearchParams(queryString);
}
